module.exports = __webpack_public_path__ + "img/rule_bet.27fcaaa4.png";